module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/events-calendar.json
// module id = 1914
// module chunks = 187670924316574